import Skybox from './Skybox';

export default Skybox;